import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import PhotoVideography from './pages/PhotoVideography';
import PrePostWedding from './pages/PrePostWedding';
import FashionShoot from './pages/FashionShoot';
import CorporateEvents from './pages/CorporateEvents';
import BabyShoots from './pages/BabyShoots';
import Ads from './pages/Ads';
import Podcast from './pages/Podcast';
import FilmMaking from './pages/FilmMaking';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ExternalDataDisplay from './components/ExternalDataDisplay';
import ImageModal from './components/ImageModal';
import ScrollToTop from './components/ScrollToTop';
import { ImageModalProvider } from './contexts/ImageModalContext';

function App() {
  return (
    <ImageModalProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/photo-videography" element={<PhotoVideography />} />
            <Route path="/pre-post-wedding" element={<PrePostWedding />} />
            <Route path="/fashion-shoot" element={<FashionShoot />} />
            <Route path="/corporate-events" element={<CorporateEvents />} />
            <Route path="/baby-shoots" element={<BabyShoots />} />
            <Route path="/ads" element={<Ads />} />
            <Route path="/podcast" element={<Podcast />} />
            <Route path="/film-making" element={<FilmMaking />} />
            <Route path="/live-streaming" element={<ExternalDataDisplay />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <ImageModal />
        </div>
      </Router>
    </ImageModalProvider>
  );
}

export default App;
